import { z } from 'zod';

/** The answer of `GET /api/health`: the service is up, and which build it is. */
export const HealthResponse = z.object({
  ok: z.literal(true),
  version: z.string().min(1),
  time: z.string().min(1),
});
export type HealthResponse = z.infer<typeof HealthResponse>;
